import { Component } from "react";
import * as language from "../constants/languages";
import { getAboutData, getSupportData } from "../services/services";
import HeaderCommon from "../components/HeaderCommon";

class AboutUsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      data: "",
      number: [],
    };

    this.state.email = [];
  }
  componentDidMount() {
    this.getStaticData();
  }
  async getStaticData() {
    this.getAboutData();
    this.getSupportInfoData();
  }
  // get about us data
  async getAboutData() {
    await getAboutData(language.companyidValue).then((aboutData) => {
      if (aboutData.status === "success") {
        this.setState({
          data: aboutData.data,
          isLoading: false,
        });
      }
    });
  }

  async getSupportInfoData() {
    await getSupportData(language.companyidValue).then((supportData) => {
      if (supportData.status === "success") {
        if (supportData.data.contactNos != null) {
          if (supportData.data.contactNos.length > 1) {
            this.setState({
              number: supportData.data.contactNos.split(","),
            });
          } else {
            this.setState({
              number: supportData.data.contactNos,
            });
          }
        } else {
          this.setState({
            number: [],
          });
        }
        if (supportData.data.contactEmail != null) {
          if (supportData.data.contactEmail.length > 1) {
            this.setState({
              email: supportData.data.contactEmail.split(","),
            });
          } else {
            this.setState({
              // email: supportData.data.contactEmail
              email: supportData.data.contactEmail,
            });
          }
        } else {
          this.setState({
            email: [],
          });
        }
        if (supportData.data.contactus != null) {
          if (supportData.data.contactus.length > 1) {
            this.setState({
              contactus: supportData.data.contactus.split(","),
            });
          } else {
            this.setState({
              contactus: supportData.data.contactus,
            });
          }
        } else {
          this.setState({
            contactus: [],
          });
        }
      }
    });
  }
  render() {
    return (
      <div>
        <HeaderCommon />
        <div>
          <h3 className="text-30px poppins-semibold text-base max-container px-3 mb-2">
            About Us
          </h3>
          <div>
            <div className="max-container mx-auto row">
              <div className="col-xl-6 visible-image-wrapper">
                <img
                  src="/images/about.png"
                  alt="about.png"
                  className="object-fit-contain w-100"
                />
              </div>
              <div className="col-xl-6 image-wrapper">
                <img
                  src="/images/about.png"
                  alt="about.png"
                  className="team-image"
                />
                <div class="long-blue-block" />
                <div class="blue-block">
                  <div className="poppins-semibold aboutUsTitle">About Us</div>
                </div>
                <div class="grey-block">
                  <div class="l-shape"></div>
                </div>
              </div>
              <div className="col-xl-6">
                <h5 className="poppins-semibold text-35px my-3">
                  Vyaparstore.com
                </h5>
                <p className="poppins-medium text-30px">
                  The Exclusive Merchants Outlet The Complete Billing Solutions
                  Provider & Your Delivery Partner
                </p>
                <p className="text-justify text-base poppins-light lh-lg">
                  Our concept Store Called VYAPARSTORE has its relevance here, a
                  merchant by visiting the nearest experience center can first
                  see for themselves the different hardware and software options
                  showcased in the store and the display Stand which has listed
                  details with price will help them to understand the concept or
                  option displayed in each case.
                </p>
                <p className="text-justify text-base poppins-light lh-lg">
                  After going through all the different hardware and software
                  options available for billing, labelling, barcoding etc... the
                  customer will be assisted by our well-trained technical team
                  to choose the best option for them based on the financials
                  available with the customer.
                </p>
              </div>
            </div>
            <div className="max-container mx-auto row my-5">
              <div className="col-lg-6">
                <div className="d-flex align-items-center">
                  <img src="/images/vision.png" className="visionImageStyle" />
                  <h6 className="text-30px poppins-medium">Our Vision </h6>
                </div>
                <p className="text-justify text-base poppins-light lh-lg">
                  To revolutionize retail and business automation by creating
                  accessible, reliable, and customer-friendly experience centers
                  where every merchant can explore and adopt the right
                  technology solutions with confidence. We aim to become the
                  most trusted destination for practical, affordable, and
                  innovative retail tech solutions.
                </p>
              </div>
              <div className="col-lg-6">
                <div className="d-flex align-items-center">
                  <img src="/images/mission.png" className="visionImageStyle" />
                  <h6 className="text-30px poppins-medium">Our Mission</h6>
                </div>
                <p className="text-justify text-base poppins-light lh-lg">
                  To empower merchants with hands on access to cutting edge
                  hardware and software solutions through our VyaparStore
                  experience centers, backed by expert guidance, transparent
                  pricing, and personalized support making digital
                  transformation simple, efficient, and cost effective.
                </p>
              </div>
            </div>
            <div style={{ backgroundColor: "#BADEFF" }}>
              <div className="max-container mx-auto py-5 mb-5">
                <p className="text-center poppins-light text-base fw-bold">
                  Watch product demos, customer stories, and explore our
                  experience center virtually. Get a closer look at how
                  VyaparStore transforms businesses with smart retail and
                  billing solutions.
                </p>
                <div className="d-flex justify-content-center align-items-center flex-column">
                  <a
                    href="https://www.youtube.com/@vyaparstore7807"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <button className="youtubeVideoButton text-white poppins-medium">
                      <img
                        src="/images/youtube.png"
                        alt="youtube"
                        className="youtubeImageStyle"
                      />
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div className="max-container mx-auto px-2">
              <p className="text-justify text-base poppins-light lh-lg">
                VYAPAR STORE is a Trade mark registered brand and SPIDER TECHNO
                SOFT PVT. LTD, Kochi which owns this emerging brand along with
                few other trade mark brands in their basket. This is a concept
                store and it has been visualized as an experience center and its
                a must place of visit for any MERCHANT who wishes to start a
                business. The quality time which he or she spends at a VYAPAR
                STORE will help and support them to clear a minimum one dozen
                doubts, and but on many important points. At this juncture any
                crucial decisions, which if taken uninformed or biased may have
                fatal impacts on the total functioning of the business on both
                short term and long term.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                Our concept Store Called VYAPARSTORE has its relevance here, a
                merchant by visiting the nearest experience center can first see
                for themselves the different hardware and software options
                showcased in the store and the display Stand which has listed
                details with price will help them to understand the concept or
                option displayed in each case. After going through all the
                different hardware and software options available for billing,
                labelling, barcoding etc... the customer will be assisted by our
                well-trained technical team to choose the best option for them
                based on the financials available with the customer. All these
                processes will be very informative and based on dialogues with
                the customer thus need assessment of the customer happens here
                and customer in turn will also get to know the options available
                for him to successfully start a state of art technology driven
                solutions which are at par with the market and expectations of
                the end customer who are the ultimate beneficiaries of such
                products and solutions are also met in this manner.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                Such a Concept Store has been Inaugurated at Vazhuthacaud,
                Thiruvananthapuram on July 15th by Hon. Transport Minister Mr.
                Antony Raju and the store has been promoted by the four
                Directors of Spider Techno Soft Pvt Ltd as a different
                partnership company called STS Technologies. The store
                interiors, the furnishing models, the main display name boards
                all are finalized after many thoughts process and it has been
                made mandatory to follow for setting up a franchise store at all
                other district headquarters. We are already in full flow with a
                Branch store STS Info Solutions at Arayidathupalam, Calicut
                successfully operating since 3 Years.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                Along with these Spider Techno Soft Pvt. Ltd widened our
                Vyaparstore Franchise Concept to North Kerala Market in tie up
                with Vestano India LLP, they are running  a Vyapartsore
                Franchise Main Store at Anamangad, Malappuram; planning, also we
                have opened our 5th  Vyapar Store Franchise showroom at
                Nagampadam, Kottayam Franchise owned by VS Technologies,
                inaugurated on 28thFebruary 2022 by Hon. Minister for
                Cooperation & Registration Sri. V N Vasavan. also we have opened
                our 6th  Vyapar Store Franchise showroom at Thrissur , Thrissur
                Franchise owned by Future Retail Solutions 20th January 2024 by
                Sri. Abdul Hameed, also we have opened our 7th  VyaparStore
                Franchise showroom at Calicut , Calicut Franchise owned by
                Vestano International LLP 17th February 2024 As part of widening
                the service VyaparStore planning to open more main stores in
                other districts also.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                We have introduced 2different investment proposals for letting
                Vyaparstore franchise model roll out for PAN INDIA, Primary one
                is Vyaparstore Franchise Main Store Concept, which will have
                an initial investment around Rs.12 lakhs, and the second one is
                Vyaparstore Micro store concept, relatively a smaller investment
                model around Rs.6 lakhs. Our plan is to operate one Main store
                in each district; under the supervision of that main store in
                every 25 kms radius one micro store will operate. This is a
                great opportunity for small scale investors and those who wish
                to convert their presently operated mobile shops or laptop
                stores to operate as micro Vyaparstore. The macro store or the
                main store must have minimum 450 to 650 sq ft available floor
                space and whereas the micro store should operate at 200-350 sq
                ft.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                We plan to open up atleast 12 to 14 Main Vayapar Stores at all
                districts of Kerala our Home State with in a year and under this
                main Vyapar Store there will be micro stores covering all main
                cities and towns and at an average 25 kms radius and such micro
                stores will be doing business under the main Vyapar Store.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                The same concepts will be spread across all Southern States in
                coming years initially and then to PAN INDIA by taking all the
                experience gained so far and updating the latest technologies
                available internationally to our native merchant customers and
                dealer partners.
              </p>
            </div>
            <div className="max-container mx-auto px-2">
              <h2 className="text-30px text-center mt-5 mb-4 poppins-medium">
                VyaparStore Online
              </h2>
              <p className="text-justify text-base poppins-light lh-lg">
                Vyapar Store has an online store too with a domain
                name www.vayparstore.com which is an E-commerce platform which
                uses our own E-commerce technology. At the ONLINE STORE which is
                designed basically for the customers wherein we target to reach
                out to every customer who are not fully aware of the latest
                trends and developments in the industry. We envisage ourselves
                as an intermediary to introduce latest technology driven
                hardwares and software to drive this hardware at reasonable cost
                to our Franchise partners and to our end customers. Our online
                store has been made in such a way that customers can literally
                feel the pleasure of a virtual shopping by going through the
                details of each and every product, assessing its relevance and
                requirements to their business needs etc... and they can make a
                right choice and we have also provided a technical help to chat
                with our technical experts to help them an informed decision on
                any product or services.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                The offline store will function as experience centre as
                described above where merchants can come operate it by
                themselves using designated software, operate all peripherals
                connected to the main system or POS MACHINES and thus gain an
                overview of the operations being planned for their store.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                Here we are proud that we could roll out a concept at its both
                levels{" "}
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                1. Virtual level as online e-commerce platform; <br /> 2. in
                real touch and feel level as off line store.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                We are even proud that we could sell our concept franchise
                offline Main store to an externally invested partner called M/s.
                Vestano India LLP for Malappuram District at Anamangad near
                Perinthalmanna. If someone has doubts Why Anamangad relatively
                small town of Malappuram District but this place has got a very
                big importance as this place is a very big market place which
                houses HYPERMAEKT AND SUPERMARKETRACKS and there are multiple
                factories which produces such racks and there arebig import
                players located at this area who deals in importing of such
                racksfrom overseas markets.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                Talks are on and are at different levels of discussion for South
                and Central Kerala franchise showrooms.
              </p>
            </div>
            <div className="max-container mx-auto px-2">
              <h2 className="text-30px text-center mt-5 mb-4 poppins-medium">
                Entrepreneurship Development Program (EDP Concept)
              </h2>
              <p className="text-justify text-base poppins-light lh-lg">
                We have also developed a program called Entrepreneurship
                Development Program to develop Trained Entrepreneurship
                Development Partner (EDP) under this program we intent to employ
                more than 1000+ skilled and unskilled persons who are regularly
                in the fields for their jobs meeting different levels of people
                formal walks of life like marketing & Sales executives of other
                fields, LICAGENTS, NBFC daily collection agents, R.D agents,
                skilled and unskilled labour forces who are related to the works
                of interiors etc.. Identify such people who have access to or
                knowledge of starting of new business ventures and this
                information which is basically a business lead for business for
                our VyaparStores and micro stores.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                EDP has to pass on such leads to the nearest Vyapar Store or
                Micro Store to which they are mapped in each place and the sales
                and marketing staffs of Vyapar Store will take all necessary
                Steps to meet the responsible persons who intent to start a
                business and the EDP who has passed the lead will be rewarded
                well after successful completion of that referred business.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                Joining hand with our external franchise investment partners we
                plan to expand the EDP network in a big way and we propose to
                have such EDPs working under every VYPAR STORES. We believe this
                is the only way to increase the business leads and we can
                penetrate to the grass root level of each business potential
                areas only by DELVELOPING EDPs.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                We value our customers like our Family and glad to grow together
                in the industry.
              </p>

              <p className="text-justify text-base poppins-light lh-lg">
                Purchase can made through either online web portal
                vyaparstore.com or through mobile application available with
                your play store. User-friendly interface facilitating payment
                gateways of different entities like Credit Cards, Debit Cards,
                UPI, Net-Banking, Wallets etc... Immediately on order completion
                confirmation is send through SMS to your registered mobile.
                Assured delivery within the specified period through safe mode
                of transport.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default AboutUsPage;
